(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["image-swiper"] && !Shopify.designMode) return;
  try {
    class ImageSwiper {
    constructor(element) {
      this.element = element;
      this.track = element.querySelector('.image-swiper__track');
      this.slides = element.querySelectorAll('.image-swiper__slide');
      this.prevButton = element.querySelector('.image-swiper__arrow--prev');
      this.nextButton = element.querySelector('.image-swiper__arrow--next');
      this.currentSlide = 0;
      this.totalSlides = this.slides.length;
      this.autoSwipe = element.dataset.autoSwipe === 'true';
      this.swipeInterval = parseInt(element.dataset.swipeInterval) || 3000;
      this.intervalId = null;

      this.init();
    }

    init() {
      if (this.totalSlides <= 1) return;

      this.setupEventListeners();

      if (this.autoSwipe) {
        this.startAutoSwipe();
      }

      this.element.addEventListener('mouseenter', () => this.pauseAutoSwipe());
      this.element.addEventListener('mouseleave', () => this.resumeAutoSwipe());
    }

    setupEventListeners() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.prevSlide());
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.nextSlide());
      }

      let startX = 0;
      let currentX = 0;
      let isDragging = false;

      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
        this.pauseAutoSwipe();
      });

      this.track.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        currentX = e.touches[0].clientX;
      });

      this.track.addEventListener('touchend', () => {
        if (!isDragging) return;
        isDragging = false;

        const diffX = startX - currentX;
        if (Math.abs(diffX) > 50) {
          if (diffX > 0) {
            this.nextSlide();
          } else {
            this.prevSlide();
          }
        }

        this.resumeAutoSwipe();
      });
    }

    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
      this.updateSlidePosition();
    }

    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
      this.updateSlidePosition();
    }

    updateSlidePosition() {
      const translateX = -this.currentSlide * 100;
      this.track.style.transform = `translateX(${translateX}%)`;
    }

    startAutoSwipe() {
      if (this.totalSlides <= 1) return;

      this.intervalId = setInterval(() => {
        this.nextSlide();
      }, this.swipeInterval);
    }

    pauseAutoSwipe() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    resumeAutoSwipe() {
      if (this.autoSwipe && !this.intervalId) {
        this.startAutoSwipe();
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    const swipers = document.querySelectorAll('.image-swiper');
    swipers.forEach((swiper) => new ImageSwiper(swiper));
  });

  document.addEventListener('shopify:section:load', function (event) {
    const swipers = event.target.querySelectorAll('.image-swiper');
    swipers.forEach((swiper) => new ImageSwiper(swiper));
  });
  } catch(e) { console.error(e); }
})();

})();
